import { ImageCrop } from '@shared/Frontend/components/img'
import { CMSImage } from './cmsImage.state'

export type ImageResponse = FileResponse & ImageBase & { formats: string }

export type FileResponse = {
  size: number
  alternativeText?: string
  caption?: string
  provider?: FileProvider
  url: string
}

type FileProvider = 'AWS_S3'

type ImageBase = { height: number; width: number }

type ImageFormat = { ext: string; hash: string; mime: string; name: string; url: string } & ImageBase

type ImageFormatsJSON = {
  [key in ImageSize]?: ImageFormat
}

export type ImageSize = (typeof imageSizes)[number]

type ImageSizeString = `${number}x${number}` | `${number}w` | `${number}h`

export const defaultSrcSet = [
  '592w',
  '1184w',
  '1776w',
  '2368w',
]

export const pageHeaderSrcSet = [
  '444x444',
  '888x888',
  '1776x1776',
] satisfies ImageSizeString[]

export const homeHeaderSrcSet = [
  '510x391',
  '1020x782',
  '2040x1564',
] satisfies ImageSizeString[]

export const ctaSrcSet = [
  '576x576',
  '1152x1152',
] satisfies ImageSizeString[]

export const gridSrcSet = [
  '384x300',
  '768x600',
] satisfies ImageSizeString[]
export const simpleGridSrcSet = [
  '80x80',
  '160x160',
  '320x320'
] satisfies ImageSizeString[]

export const logoSrcSet = [
  '98w',
  '196w',
] satisfies ImageSizeString[]

export const mediaSrcSet = [
  '592w',
  '1184w',
  '1776w',
  '2368w',
] satisfies ImageSizeString[]

export const quoteSrcSet = [
  '176x176',
  '352x352'
] satisfies ImageSizeString[]

export const recentsSrcSet = [
  '176x176',
  '352x352'
] satisfies ImageSizeString[]

export const textImageSrcSet = [
  '592w',
  '1184w',
  '1776w'
] satisfies ImageSizeString[]

export const brochureSrcSet = [
  '384x546',
  '768x1092',
  '1536x2184'
] satisfies ImageSizeString[]

const imageSizes = [
  ...defaultSrcSet,

  ...pageHeaderSrcSet,
  ...homeHeaderSrcSet,
  ...ctaSrcSet,
  ...gridSrcSet,
  ...logoSrcSet,
  ...mediaSrcSet,
  ...quoteSrcSet,
  ...recentsSrcSet,
  ...textImageSrcSet,
  ...brochureSrcSet
]

export const cmsImageParser =
  (allowedCrops: ImageSize[]) =>
  ({ url, formats, alternativeText }: ImageResponse): CMSImage => {
    const formatsJSON: ImageFormatsJSON = formats == undefined ? {} : JSON.parse(formats)
    return {
      alt: alternativeText || '',
      src: url,
      crops: (Object.entries(formatsJSON) as [ImageSize, ImageFormat][])
        .filter(([key]) => allowedCrops.includes(key))
        .map(([_, format]): ImageCrop => ({ width: format.width, url: format.url })),
    }
  }
